import { render, staticRenderFns } from "./TgpJoinUrl.vue?vue&type=template&id=34546832"
import script from "./TgpJoinUrl.vue?vue&type=script&lang=js"
export * from "./TgpJoinUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports